export default __webpack_public_path__ + "static/10years-f96378666a542e3c3f40d390ac930687.png";